import { sdk } from '@/sdk';
import { useCallback } from 'react';
import useSWR from 'swr';
//import { revalidateOptions } from 'frontastic';

const useProduct = (): any => {
  // Commented out for faster login redirect - categories can be loaded lazily
  // const { data } = useSWR('/action/product/queryCategories', () =>
  //   sdk.callAction<any>({ actionName: 'product/queryCategories', query: { format: 'tree' } }),
  // );

  // Provide empty data for faster initial load
  const data = { isError: false, data: { items: [] } };
  const categories = (data?.isError ? [] : (data?.data?.items as any)) ?? [];

  const query = useCallback(async (productQuery: any) => {
    /* To Do: Use SDK instead of current workaround */

    const extensions = sdk.composableCommerce;

    const res = await extensions.product.query({ limit: productQuery.limit, query: productQuery.query });

    return res;

    // const params = new URLSearchParams();

    // if (productQuery.query) params.set('query', productQuery.query);
    // if (productQuery.limit) params.set('limit', productQuery.limit);

    // const res = await fetchApiHub(`/action/product/query?${params.toString()}`, SDK.locale);

    // return { data: res, isError: false } as SDKResponse<Result>;
  }, []);

  const downloadFiles = useCallback(async (payload: any) => {
    const extensions = sdk.composableCommerce;

    // const res = await extensions.product.downloadFiles(payload);

    // return res;
  }, []);

  const fetchJWTToken = useCallback(async () => {
    const extensions = sdk.composableCommerce;

    // const res = await extensions.product.getJWTToken();

    // return res;
  }, []);

  const getRelatedProducts = useCallback(async (payload: any) => {
    const extensions = sdk.composableCommerce;
    // const res = await extensions.product.getRelatedProducts(payload);

    // return res.isError ? {} : res.data;
  }, []);
  

  const getBundleData =  useCallback(async (payload: any) => {
    const extensions = sdk.composableCommerce;
    // const res = await extensions.product.getBundleData(payload);
    // return res.isError ? {} : res.data;
  }, []);

  return { categories, query, downloadFiles,fetchJWTToken, getRelatedProducts, getBundleData };
};

export default useProduct;